//обработка форм авторизации и регистрации
module.exports = () => {
    let passwordForgot = $('#password-forgot').on('change', function() {
            let form = $(this).closest('form');

            form.find('.form__password').toggle().find('input').toggleClass('required');
            form.find(':submit').text(this.checked ? 'Выслать новый пароль' : 'Войти');
            form.attr('action', this.checked ? '/auth/login/passwordRecover' : '/auth/login');
        });

    let onSuccess = function(json, button) {
        if (json.buttonText) {
            button.text(json.buttonText);
        }

        if (passwordForgot.is(':checked')) {
            passwordForgot.click();
        }

        if (json.removeSubmit) {
            button.remove();
        }

        if (json.success) {
            document.getElementById('auth-success').innerHTML = json.success;
        } else if (json.ret) {
            location.href = button.data('from');
        }
    };

    let onError = function(json, button) {
        if (json.html) {
            button.siblings().remove().end().before(json.html);
            button.prev().find('input').css('border', '1px solid silver');
        }

        if (json.action) {
            button.closest('form').attr('action', json.action);
        }

        swal.fire('Внимание!', json.msg, 'warning');
    };

    [document.getElementById('formAuth'), document.getElementById('formReg')].forEach(form => {
        $app.maskPhone(form)
        $(form).easyValidate(onSuccess, onError)
    })

    $('#auth-form .nav-item').on('click', event => {
        event.preventDefault()

        $(event.target).addClass('active').siblings().removeClass('active')
        $('#' + event.target.href.split('#')[1]).removeClass('d-none').siblings('.tab-pane--small').addClass('d-none')
    })
};